import { Currency } from '@/core/currency/interfaces';

const NGN: Currency = {
    name: 'Nigerian Naira',
    demonym: 'Nigerian',
    majorSingle: 'Naira',
    majorPlural: 'Naira',
    codeNumeric: '566',
    symbol: '₦',
    symbolNative: '₦',
    minorSingle: 'Kobo',
    minorPlural: 'Kobo',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'NGN',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default NGN;
